import { CIcon } from '~/icons/types'

export const ciPencil: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.56 4.44a1.5 1.5 0 0 0-2.12 0l-.794.792 2.122 2.122.793-.793a1.5 1.5 0 0 0 0-2.122Zm-2.206 4.328-2.122-2.122L4 17.88v2.156h2.086L17.354 8.768Zm-1.329-5.743a3.5 3.5 0 1 1 4.95 4.95L7.207 21.743a1 1 0 0 1-.707.293H3a1 1 0 0 1-1-1v-3.572a1 1 0 0 1 .293-.707L16.025 3.025Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'pencil',
  type: 'regular'
}
